'use client';

import { FontSize } from '@app/domain/model/FontSize';
import { createContext } from 'react';

interface AccessibilityContextValue {
    fontSize: string;
    isHighContrastMode: boolean;
}

export const AccessibilityContext = createContext<AccessibilityContextValue>({
    fontSize: FontSize.Normal,
    isHighContrastMode: false,
});
